import { ToastrService } from "ngx-toastr";
import {ToastMode} from "./include/structures";
import { Injectable } from '@angular/core';
import { Globals } from "./globals";

@Injectable()
export class Message{
    
    constructor(private toastr: ToastrService){}
    
    showToaster(message:string,mode:string=ToastMode.INFO,title:string=""){
        Globals.setLoading(false);
        switch(mode){
          case ToastMode.SUCCESS:
            this.toastr.success(message,title);
            break;
          
          case ToastMode.INFO:
            this.toastr.info(message,title);
            break;
          
          case ToastMode.DANGER:
            this.toastr.error(message,title);
            break;
    
          case ToastMode.WARNING:
            this.toastr.warning(message,title);
            break;

          
        }
    
    }
    

}